export const TOOLTIP_DELAY_MS = 500;
